import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CheckDigitalProfile, CheckDigitalProfileFound, CheckDigitalProfileNotFound, CreateProfileProductTypeSuccess, GetPhoneByWalletIdFound, GetPhoneByWalletIdNotFound, RegisterNewProfile, RegisterNewProfileSuccess, SetWalletId, UpdateProfileProductType, UpdateProfileProductTypeSuccess } from "./auth.actions";
import { catchError, map, mergeMap, of } from "rxjs";
import { SignInService } from "src/app/services/sign-in.service";
import { GetPhoneByWalletIdResponse, RiskStatus } from "./auth.model";
import { createInternationalPhoneNumber } from "src/app/feature/sign-in/utils/phone-utils";
import { CheckDigitalProfileResponse, ProfileDetails, RegisterNewProfileResponse, UserPhoneDetails } from "src/app/models/sign-in.models";

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private signInService: SignInService
  ) {}

  public getPhoneByWalletId$ = createEffect(() => 
    this.actions$.pipe(
      ofType(SetWalletId),
      mergeMap(({walletId}) => {
        return this.signInService.getPhoneByWallet(walletId).pipe(
          map((res: GetPhoneByWalletIdResponse) => {
            if (res?.consumer ?? false) {
              const { countryDialCode, number } = res.consumer.mobilePhone;
              const { digitalProfileId } = res;
              // Todo: Tim: #may6 - revisit this, there may be a better way to capture riskStatus attributes
              let riskStatus: RiskStatus | null;
              // console.log('res.hasOwnProperty("isStepUpRequired")', res.hasOwnProperty("isStepUpRequired")); // Todo: remove: #may6
              // console.log('res.hasOwnProperty("isRedirectRequired")', res.hasOwnProperty("isRedirectRequired")); // Todo: remove: #may6
              if (res.hasOwnProperty('isStepUpRequired') && res.hasOwnProperty("isRedirectRequired")) {
                // console.log('IF res', res); // Todo: remove: #may6
                riskStatus = {
                  isStepUpRequired: res.isStepUpRequired,
                  isRedirectRequired: res.isRedirectRequired,
                  journeyToken: res?.journeyToken ?? '',
                  journeyKey: res?.journeyKey ?? ''
                }
              }
              else {
                // console.log('ELSE res', res); // Todo: remove: #may6
                riskStatus = null
              }
              const phoneDetails = this.generateUserPhoneDetails(countryDialCode, number)
              return GetPhoneByWalletIdFound({phoneDetails, digitalProfileId, riskStatus})
            }
            else {
              return GetPhoneByWalletIdNotFound()
            }
          }),
          // catchError((error) => { // Todo: Tim: add error handling #mar25
          //   return
          // })
        )
      })
    )
  )

  public checkDigitalProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CheckDigitalProfile
      ),
      mergeMap(({phoneNumber, countryDialCode}) => { // Todo: Tim: #mar25 fix type
        return this.signInService.checkDigitalProfile(phoneNumber, countryDialCode).pipe(
          map((res: CheckDigitalProfileResponse) => {
            if (res?.digitalProfileId && res.digitalProfileId !== undefined) {
              return CheckDigitalProfileFound(res);
            }
            else {
              return CheckDigitalProfileNotFound(res);
            }
          }),
          // catchError((error) => { // Todo: Tim: add error handling #mar25
          //   return
          // })
        )
      })
    )
  )

  public createProfileProductType$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        RegisterNewProfileSuccess
      ),
      mergeMap(({res, walletId}) => {
        return this.signInService.updateProfileProductType(res.digitalProfileId, walletId).pipe(
          map((res: any) => {
            return CreateProfileProductTypeSuccess();
          })
          // catchError((error) => { // Todo: Tim: add error handling #mar25
          //   return
          // })
        )
      })
    ),
  )

  public updateProfileProductType$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        UpdateProfileProductType
      ),
      mergeMap(({ dpid, walletId}) => {
        console.log('updateProfileProductType - dpid', dpid); // TOdo: remove: #may6
        return this.signInService.updateProfileProductType(dpid, walletId).pipe(
          map((res: any) => {
            return UpdateProfileProductTypeSuccess();
          })
          // catchError((error) => { // Todo: Tim: add error handling #mar25
          //   return
          // })
        )
      })
    ),
  )

  public registerNewProfile$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        RegisterNewProfile
      ),
      mergeMap((profilePayload: ProfileDetails) => {
        return this.signInService.registerNewProfile(profilePayload).pipe(
          map((res: RegisterNewProfileResponse) => {
              let riskStatus: RiskStatus
              riskStatus = {
                isStepUpRequired: res.isStepUpRequired,
                isRedirectRequired: res.isRedirectRequired,
                journeyToken: res.journeyToken,
                journeyKey: res.journeyKey
              }
            return RegisterNewProfileSuccess({ res, riskStatus, walletId: profilePayload.walletId});
          }),
          // catchError((error) => { // Todo: Tim: add error handling #mar25
          //   return
          // })
        )
      })
    )
  )

  private generateUserPhoneDetails(countryDialCode: string, phoneNumber: string): UserPhoneDetails {
    const internationalPhoneNumber = createInternationalPhoneNumber(countryDialCode, phoneNumber);
    const phoneDetails = {
      phoneNumber,
      countryDialCode,
      internationalPhoneNumber
    }
    return phoneDetails;
  }
}